/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExpressionCorrectionRequest
 */
export interface ExpressionCorrectionRequest {
    /**
     * Corrected value of the expression
     * @type {string}
     * @memberof ExpressionCorrectionRequest
     */
    newValue: string;
    /**
     * the unique identifier of new entry
     * @type {string}
     * @memberof ExpressionCorrectionRequest
     */
    patientEntryUuid: string;
    /**
     * Reason for the correction
     * @type {string}
     * @memberof ExpressionCorrectionRequest
     */
    reason?: string;
}

/**
 * Check if a given object implements the ExpressionCorrectionRequest interface.
 */
export function instanceOfExpressionCorrectionRequest(value: object): value is ExpressionCorrectionRequest {
    if (!('newValue' in value) || value['newValue'] === undefined) return false;
    if (!('patientEntryUuid' in value) || value['patientEntryUuid'] === undefined) return false;
    return true;
}

export function ExpressionCorrectionRequestFromJSON(json: any): ExpressionCorrectionRequest {
    return ExpressionCorrectionRequestFromJSONTyped(json, false);
}

export function ExpressionCorrectionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExpressionCorrectionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'newValue': json['newValue'],
        'patientEntryUuid': json['patientEntryUuid'],
        'reason': json['reason'] == null ? undefined : json['reason'],
    };
}

export function ExpressionCorrectionRequestToJSON(json: any): ExpressionCorrectionRequest {
    return ExpressionCorrectionRequestToJSONTyped(json, false);
}

export function ExpressionCorrectionRequestToJSONTyped(value?: ExpressionCorrectionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'newValue': value['newValue'],
        'patientEntryUuid': value['patientEntryUuid'],
        'reason': value['reason'],
    };
}

